export const PRODUCTS = [
  {
    slug: "single-bar",
    sku: "ZENTRA-BAR-1",
    title: "Single Bar",
    short: "50 g",
    price: 109,
    compareAt: null,
    image: "/assets/hero-bar-box.webp",
    description: "One 50 g bar — the easiest way to try Zentra.",
    nutrition:
      "10g Plant Protein | 2g Horse gram Microgreens. Trans-fat free. No added sugar. Energy, immunity, natural nutrition.",
    in_stock: true,
  },
  {
    slug: "box-of-4",
    sku: "ZENTRA-BOX-4",
    title: "Box of 4",
    short: "4 × 50 g (200 g)",
    price: 392,
    compareAt: 436,
    image: "/assets/hero-bar-box.webp",
    description: "Four bars for the week: office, gym or travel.",
    nutrition:
      "10g Plant Protein | 2g Horse gram Microgreens. Trans-fat free. No added sugar.",
    in_stock: true,
  },
  {
    slug: "box-of-8",
    sku: "ZENTRA-BOX-8",
    title: "Box of 8",
    short: "8 × 50 g (400 g)",
    price: 749,
    compareAt: 872,
    image: "/assets/hero-bar-box.webp",
    description: "Eight bars for daily fuelling — our best value per bar.",
    nutrition:
      "10g Plant Protein | 2g Horse gram Microgreens. Trans-fat free. No added sugar.",
    in_stock: true,
  },
];

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);

export const inr = (n) => `₹${n.toLocaleString("en-IN")}`;

export const savingsBadge = (p) =>
  p.compareAt && p.compareAt > p.price ? `Save ₹${p.compareAt - p.price}` : null;

export const offLabel = (p) =>
  p.compareAt && p.compareAt > p.price
    ? `${Math.round(((p.compareAt - p.price) / p.compareAt) * 100)}% OFF`
    : null;
